/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs */



/**
* | output |
* | --- |
* | "Audio Description Plugin Not Activated" |
*
* @param {Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_ad_plugin_not_activated_error = /** @type {((inputs?: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plugin de description audio non active")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiobeschreibungs-Plugin nicht aktiviert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Plugin di descrizione audio non attivato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Плагин аудиоописания не активирован.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Plugin de descripción de audio no activado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频描述插件未激活")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声解説プラグインが有効化されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण प्लगइन सक्रिय नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Plugin de descrição de áudio não ativado")
	return /** @type {LocalizedString} */ ("Audio Description Plugin Not Activated")
});